export default __webpack_public_path__ + "static/media/ic_aave_30.47eb886f.svg";